import { useResturantGroupByGroupIdQuery } from 'generated/sanity-graphql';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

interface IUseRestaurantGroups {
  loading: Boolean;
  data:
    | {
        name: String | null;
        restaurants: any;
      }
    | undefined;
  storeHasMobileLoyalty: (storeId: string) => boolean;
}

export const useRestaurantGroups = (groupId: string): IUseRestaurantGroups => {
  const enableLoyaltyTags = useFlag(LaunchDarklyFlag.ENABLE_LOYALTY_TAGS_STORE_LOCATOR);

  const response = useResturantGroupByGroupIdQuery({
    variables: {
      id: groupId,
    },
    skip: !enableLoyaltyTags,
  });

  const storeHasMobileLoyalty = (storeId: string) => {
    if (response?.loading) {
      return false;
    }
    return !(response?.data?.allRestaurantGroups[0]?.restaurants || []).some(
      (r: any) => r.number === storeId
    );
  };

  return {
    loading: response?.loading,
    data: response?.data?.allRestaurantGroups[0],
    storeHasMobileLoyalty,
  };
};
